// extracted by mini-css-extract-plugin
export default {"overlay":"LoaderLogin_overlay__33pCW","loader":"LoaderLogin_loader__FhWVF","bounce":"LoaderLogin_bounce__hBcwj"};